let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d7F5K")).then(() => parcelRequire('7nWGC'));